import { useEffect } from 'react'
import { ActorRef } from '@artblocks/sdk/dist/machines/utils'
import { ArtBlocksClient } from '@artblocks/sdk'
import { useArtBlocksClient } from '@components/artblocks-provider'

export type ArtBlocksClientUpdatedEvent = {
  type: 'ART_BLOCKS_CLIENT_UPDATED'
  artblocksClient: ArtBlocksClient
}

export function useSyncMachineWithArtBlocksClient(machineRef: ActorRef<any, ArtBlocksClientUpdatedEvent, any>): void {
  const artblocksClient = useArtBlocksClient()

  useEffect(() => {
    machineRef.send({
      type: 'ART_BLOCKS_CLIENT_UPDATED',
      artblocksClient: artblocksClient
    })
  }, [machineRef, artblocksClient])
}
